function isLocalHost(hostname) {
  return hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.') ||
    hostname.startsWith('172.16.') ||
    hostname.endsWith('.local');
}

function isLocalApiBaseUrl(value) {
  try {
    const url = new URL(String(value || ''));
    return isLocalHost(url.hostname);
  } catch {
    return false;
  }
}

function normalizeConfiguredApiBaseUrl(value) {
  const normalized = String(value || '').trim().replace(/\/+$/, '');

  if (!normalized) {
    return '';
  }

  return normalized.endsWith('/api') ? normalized : `${normalized}/api`;
}

export function shouldUseConfiguredApiBaseUrl(configuredBaseUrl, options = {}) {
  if (!configuredBaseUrl) {
    return false;
  }

  if (!isLocalApiBaseUrl(configuredBaseUrl)) {
    return true;
  }

  const nodeEnv = options.nodeEnv || process.env.NODE_ENV;
  const hostname = options.hostname ||
    (typeof window !== 'undefined' ? window.location.hostname : '');

  return nodeEnv !== 'production' && (!hostname || isLocalHost(hostname));
}

export function getApiBaseUrl() {
  const configuredBaseUrl = normalizeConfiguredApiBaseUrl(process.env.REACT_APP_API_BASE_URL);

  if (shouldUseConfiguredApiBaseUrl(configuredBaseUrl)) {
    return configuredBaseUrl;
  }

  if (typeof window === 'undefined') {
    return 'http://localhost:3005/api';
  }

  if (isLocalHost(window.location.hostname) || process.env.NODE_ENV === 'development') {
    return `http://${window.location.hostname}:3005/api`;
  }

  return `${window.location.origin}/api`;
}

export function getApiUrl(endpoint = '') {
  const normalizedEndpoint = String(endpoint || '').replace(/^\/+/, '');
  return normalizedEndpoint ? `${getApiBaseUrl()}/${normalizedEndpoint}` : getApiBaseUrl();
}

export function getApiDocsUrl() {
  return `${getApiBaseUrl().replace(/\/api$/, '')}/api-docs`;
}

export function isCrossOriginApiRequest(requestUrl) {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const resolvedUrl = new URL(requestUrl, window.location.origin);
    return resolvedUrl.origin !== window.location.origin;
  } catch {
    return false;
  }
}

export function appendApiTokenToUrl(requestUrl, apiToken) {
  const trimmedToken = String(apiToken || '').trim();

  if (!trimmedToken || typeof window === 'undefined') {
    return requestUrl;
  }

  const resolvedUrl = new URL(requestUrl, window.location.origin);
  resolvedUrl.searchParams.set('apiToken', trimmedToken);
  return resolvedUrl.toString();
}
